import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { taskManagementInfo } from "../../../SchemaInfo/info";
import { EditTaskSchema } from "../../../Schemas/Task Management/edit_task";
import { useEffect } from "react";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import { BsPatchPlus } from "react-icons/bs";
import { FcCalendar } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const EditTask = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [leadOwner, setLeadOwner] = useState();
  const [tasksschema, setTasksSchema] = useState(taskManagementInfo);

  let { id } = useParams();

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handelSubmit = (values) => {
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest(
      "PATCH",
      `/tasks/updateTaskManagement/${id}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Task updated successfully!");
          navigate(`/task-management/view/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/tasks/getTaskManagementById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          // console.log(res.data);
          setTasksSchema(res.data);
        } else {
          Toast("error", "Error while getting client expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2  me-1" /> Edit Task
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Update & Track Task.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/task-management"}>
                    <button className="btn btn-primary">
                      <BsPatchPlus className="me-2 fs-2" /> VIEW TASK LIST
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>Only Super Admin and Admins can edit the task.</p>
              </div>
              <div className="card mt-2">
                <div className="card-header">
                  <h3 className="card-title">Task Difficulty Policy</h3>
                </div>

                <div className="card-body">
                  <h3>Small</h3>
                  <ul><strong>15</strong> minutes to <strong>1</strong> hours</ul>

                  <h3>Medium</h3>
                  <ul>
                    <strong>1</strong> to <strong>3</strong> hours
                  </ul>

                  <h3>Large</h3>
                  <ul>
                    Requires <strong>one</strong> full working day
                  </ul>

                  <h3>Extra Large</h3>
                  <ul>
                    Requires <strong>multiple</strong> days
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={tasksschema}
                  validationSchema={EditTaskSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Name
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="name" type="text" />
                            {props.touched.name && props.errors.name && (
                              <p className="text-danger">{props.errors.name}</p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Task type
                          </label>
                          <div className="w-100 col">
                            <div>
                              <label className="form-check form-check-inline">
                                <CustomRadioButton
                                  name="taskType"
                                  value="one time"
                                  checked={props.values.taskType === "one task"}
                                />
                                <span className="form-check-label">
                                  One Time
                                </span>
                              </label>
                              <label className="form-check form-check-inline">
                                <CustomRadioButton
                                  name="taskType"
                                  value="repeat task"
                                  checked={
                                    props.values.taskType === "repeat task"
                                  }
                                />
                                <span className="form-check-label">
                                  Repeat Task
                                </span>
                              </label>
                            </div>
                            <ErrorMessage
                              name="taskType"
                              component="p"
                              className="text-danger"
                            />
                          </div>
                        </div>
                        {props.values.taskType !== "repeat task" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Deadline
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="deadline" type="date" />
                              <ErrorMessage
                                name="deadline"
                                component="p"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}
                        {props.values.taskType === "repeat task" && (
                          <>
                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                Start date
                              </label>
                              <div className="w-100 col">
                                <CustomInput name="startDate" type="date" />
                                <ErrorMessage
                                  name="startDate"
                                  component="p"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                End date
                              </label>
                              <div className="w-100 col">
                                <CustomInput name="endDate" type="date" />
                                <ErrorMessage
                                  name="endDate"
                                  component="p"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Frequency
                              </label>
                              <div className="w-100 col">
                                <div className="d-flex">
                                  <CustomSelect
                                    className="me-2 form-select"
                                    name="frequency"
                                    type="text"
                                    style={{ width: "50%" }}
                                  >
                                    <option value="">Select</option>
                                    {[...Array(31).keys()].map((day) => (
                                      <option key={day + 1} value={day + 1}>
                                        {day + 1}
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  <CustomSelect
                                    name="frequencyType"
                                    type="text"
                                    style={{ width: "50%" }}
                                  >
                                    <option value="">Select Type</option>
                                    <option value="days">Days</option>
                                    <option value="months">Months</option>
                                    <option value="year">Year</option>
                                  </CustomSelect>
                                </div>
                                {props.touched.frequencyType &&
                                  props.errors.frequencyType && (
                                    <p className="text-danger">
                                      {props.errors.frequencyType}
                                    </p>
                                  )}
                                {props.touched.frequency &&
                                  props.errors.frequency && (
                                    <p className="text-danger">
                                      {props.errors.frequency}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Assign to
                          </label>
                          <div className="w-100 col">
                            <CustomSelect name="assignTo" type="text">
                              <option value="">Select</option>
                              {leadOwner &&
                                leadOwner?.map((pro) => {
                                  return (
                                    <option key={pro.id}>{pro.userName}</option>
                                  );
                                })}
                            </CustomSelect>
                            {props.touched.assignTo &&
                              props.errors.assignTo && (
                                <p className="text-danger">
                                  {props.errors.assignTo}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Description
                          </label>
                          <div className="w-100 col">
                            <CustomTextArea name="description" type="text" />
                            {props.touched.description &&
                              props.errors.description && (
                                <p className="text-danger">
                                  {props.errors.description}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Feedback
                          </label>
                          <div className="w-100 col">
                            <CustomTextArea name="feedback" type="text" />
                            {props.touched.feedback &&
                              props.errors.feedback && (
                                <p className="text-danger">
                                  {props.errors.feedback}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Reference image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="uploadImage"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "uploadImage",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.uploadImage &&
                              props.errors.uploadImage && (
                                <p className="text-danger">
                                  {props.errors.uploadImage}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Priority
                          </label>
                          <div className="w-100 col">
                            <CustomSelect name="priority" type="text">
                              <option value="">Select Priority</option>
                              <option value="P1">P1</option>
                              <option value="P2">P2</option>
                              <option value="P3">P3</option>
                            </CustomSelect>
                            {props.touched.priority &&
                              props.errors.priority && (
                                <p className="text-danger">
                                  {props.errors.priority}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Task Difficulty
                          </label>
                          <div className="w-100 col">
                            <CustomSelect name="taskDifficulty" type="text">
                              <option value="">Select Difficulty</option>
                              <option value="Small">Small</option>
                              <option value="Medium">Medium</option>
                              <option value="Large">Large</option>
                              <option value="ExtraLarge">Extra Large</option>
                            </CustomSelect>
                            {props.touched.priority &&
                              props.errors.priority && (
                                <p className="text-danger">
                                  {props.errors.priority}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Save Task" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditTask;
